import React from 'react';
import PropTypes from 'prop-types';
import userPictureUrlForSize from '../lib/userPictureUrlForSize';

const UserAvatar = (props) => {
  const size = 64;
  const userPictureUrl = userPictureUrlForSize(props.user.userPicture, size);
  const altText = `${props.user.displayName} avatar`;
  return <img alt={altText} src={userPictureUrl} height={size} width={size} />;
};

UserAvatar.propTypes = {
  user: PropTypes.object.isRequired
};

export default UserAvatar;


// WEBPACK FOOTER //
// ./src/views/userAvatar.js